<template>
  <div
    class="flex h-[60px] select-none items-center justify-between rounded-full border border-gray-200 p-1.5"
  >
    <button
      type="button"
      class="flex size-12 cursor-pointer items-center justify-center rounded-full bg-[#dfe1e6] transition-colors hover:bg-gray-200"
      :class="{ 'pointer-events-none opacity-40': isFirst }"
      @click="handlePrevious"
    >
      <MinusIcon class="size-5 text-gray-800" />
    </button>

    <span class="text-[20px] font-medium leading-[26px] text-gray-800">
      {{ formatNumber(selectedItem?.maxUnits || 0) }} copyrights
    </span>

    <button
      type="button"
      class="flex size-12 cursor-pointer items-center justify-center rounded-full bg-[#dfe1e6] transition-colors hover:bg-gray-200"
      :class="{ 'pointer-events-none opacity-40': isLast }"
      @click="handleNext"
    >
      <AddIcon class="size-5 text-gray-800" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { AddIcon, MinusIcon } from '@dacr/icons'
import { formatNumber } from '@/shared/utils/number'

interface QuantityItem {
  productId: string
  maxUnits?: number | null
}

const props = defineProps<{ items: QuantityItem[] }>()
const model = defineModel<string>({ required: true })

const selectedIndex = computed(() =>
  props.items.findIndex((item) => item.productId === model.value)
)
const selectedItem = computed(() => props.items[selectedIndex.value])
const isFirst = computed(() => selectedIndex.value <= 0)
const isLast = computed(() => selectedIndex.value >= props.items.length - 1)

const handlePrevious = () => {
  if (isFirst.value) return
  model.value = props.items[selectedIndex.value - 1].productId
}

const handleNext = () => {
  if (isLast.value) return
  model.value = props.items[selectedIndex.value + 1].productId
}
</script>
